import React from "react";
import InfoBoxImage from "../../src/assets/img/info-blue.svg";

const ChangeProfileCommon = {
  Title: "Change my address",
  InfoBox: {
    Any: (props, params) => (
      <p>
        This change will only apply to this plan:{" "}
        <strong>{params.MembershipNumber}</strong>. To change the details for
        your other plans, you will need to do so within each plan.
      </p>
    )
  },
  InfoBoxImage,
  BackButtonLabel: "Back",
  SubmitButtonLabel: "Submit"
};

export default ChangeProfileCommon;
